(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"] && !window.DesignMode) return;
  try {
    
/* Ici, tu pourras ajouter la mise à jour automatique prix/image si besoin */

  } catch(e) { console.error(e); }
})();
})();
